module.exports = __webpack_public_path__ + "static/assets/05f51c8a7d6f95990f879763c11f0975.png";